import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { cloneDeep, each, extend, filter, find, forEach, get, groupBy, includes, keys, orderBy, pickBy, remove, some, split, startCase, toUpper, values } from 'lodash-es';

import { BaseComponent, WmsDialogBodyComponent, WmsDialogFooterComponent, WmsDialogHeaderComponent, WmsWizardComponent, WmsMessageComponent, SelectDataSourceComponent, TemplateConfigComponent } from '@wms/components';
import { LiveListFieldConfigComponent } from '../../live-list-field-config/live-list-field-config.component';
import { WidgetPropertiesProvider } from '@wms/design-container';
import { byType, formatVariableIconClass, getFieldName, getUniqueWidgetName, initCaps, MarkupManagerService, processLiveWidgetTemplate, specialCharactersToUnderscores, StudioUtils } from '@wms/core';
import { ApisService, BindTreeUtilsService, DatabaseService, WebserviceService, ProjectService, TypeFactoryService, ServiceFactoryService } from "@wms/services";
import { replace, stringStartsWith } from '@wm/core';
import { propFactory as PropertiesFactory } from '@wm/components-base';
import { BaseVariableService, WmsLiveVariableService, VARIABLE_CONSTANTS, getServiceTypesByCollectionType } from '@wms/variables';
import { PageWsService } from '@wms/workspace';

// TODO: move to Variables constants
const SERVICE_TYPE_REST = "RestService"
// TODO: move to widget constants
const NAVIGATION_TYPE = {
  'BASIC': 'Basic',
  'CLASSIC': 'Classic',
  'ADVANCED': 'Advanced',
  'SCROLL': 'Scroll',
  'INLINE': 'Inline',
  'PAGER': 'Pager',
  'ONDEMAND': 'On-Demand'
}

@Component({
  selector: 'wms-card-widget-config',
  standalone: true,
  templateUrl: './wms-card-widget-config.component.html',
  styleUrls: ['./wms-card-widget-config.component.less'],
  imports: [
    CommonModule,
    WmsDialogBodyComponent,
    WmsDialogHeaderComponent,
    WmsDialogFooterComponent,
    WmsWizardComponent,
    WmsMessageComponent,
    TemplateConfigComponent,
    SelectDataSourceComponent,
    LiveListFieldConfigComponent
  ]
})
export class WmsCardWidgetConfigComponent extends BaseComponent implements OnInit {

  @Input() widgetDetails!: any;
  @Input() widgetInfo!: any;
  @Input() widgetType?: any = '';
  @Output() handleClose = new EventEmitter<any>();
  @Output() handleComplete = new EventEmitter<any>();

  @ViewChild('emptyTemplate') emptyTemplate: TemplateRef<any>;
  @ViewChild('selectDataSource') selectDataSourceStep: TemplateRef<any>;
  @ViewChild('templateConfig') templateConfigStep: TemplateRef<any>;
  @ViewChild('liveListFieldConfig') liveListFieldConfigStep: TemplateRef<any>;

  stepCounter: number = -1;
  showWizard = true;
  steps: Array<any> = [];
  currentStep: any;
  activeInnerStep: any;
  hasBinding: boolean = false;
  selectedLiveWidgetLayout: any;
  liveWidgetNavigation: any;
  nextBtnText: string = this.locale.LABEL_NEXT;
  message!: any;
  stepDescription: string | undefined;
  activeLiveWidget!: any;
  captionPositions = ['left', 'right', 'top', 'floating'];
  captionAlignments = ['left', 'center', 'right'];
  gridNavigations = [{ 'id': 'Basic', 'label': 'Basic' }, { 'id': 'Pager', 'label': 'Pager' }, { 'id': 'Classic', 'label': 'Classic' }, { 'id': 'On-Demand', 'label': 'On Demand' }, { 'id': 'Scroll', 'label': 'Infinite Scroll' }, { 'id': 'None', 'label': 'None' }];
  listNavigations = [{ 'id': 'Basic', 'label': 'Basic' }, { 'id': 'Pager', 'label': 'Pager' }, { 'id': 'Classic', 'label': 'Classic' }, { 'id': 'Scroll', 'label': 'Infinite Scroll' }, { 'id': 'Inline', 'label': 'Horizontal Slider' }, { 'id': 'On-Demand', 'label': 'On Demand' }, { 'id': 'None', 'label': 'None' }];
  alertMessages: any = undefined;
  isSourceMode = this.widgetType !== 'wm-carousel';
  gridOptions: { isEditable: any, canEdit: any } = {
    'isEditable': 'true',
    'canEdit': 'true'
  };
  widgetConfig = {
    'bindMode': 'variable',
    'widgetMode': 'EDITABLE',
    'formType': 'INLINE',
  };
  navigationList: any;
  liveWidgetLayouts: any;
  screens = ["layouts"];
  widgetFilter: any;
  variableFilter: any;
  widgetPropertiesProvider;
  formConfig: any;
  liveformConfig: any;
  filterConfig: any;
  gridConfig: any;
  livelistConfig: any;
  widgetDefs: any = {};
  submitInProgress = false;
  fields: any;
  markupManagerService;
  dataSourceName: any;
  dataSource: any = [];
  selectedDataSource: any = {};
  activeWidgetScope: any = {};
  listTemplate: any;
  templateWidgets: any = [];
  serviceName: any;
  showSpinner: boolean;
  showServiceSpinner: boolean = false;
  listImage: string;
  widgetList: any;
  widgetsAvailable: any;
  selectedWidget: any;
  variableList: any;
  metadataVariableList: any;
  getFilteredOptions: any;
  variableServiceTypeMap: any = {
    'RestService': 'web',
    'JavaService': 'java',
    'WebSocketService': 'web',
    'SoapService': 'web',
    'DataService': 'database',
    'OpenAPIService': 'openapi'
  };
  serviceTypeList = ['database', 'java', 'web', 'databaseapi', 'openapi'];
  filteredDataSources: any;
  showDesignButton: any;
  apiService: any;
  categoryFilterList: any;
  serviceTypes: any;
  variableCategoryFilter = includes(['wm-liveform', 'wm-livefilter'], this.widgetType) ? 'database' : 'all';
  operationText: any;
  treeData: any;
  webService: any;
  serviceFactory: any;
  databaseService: any;
  treeService: BindTreeUtilsService;
  widgetProperties: any;
  liveWidget: any;
  dataSourceTabs: any = {
    'variable': { 'name': 'variables', 'active': true, 'hasBinding': false },
    'widget': { 'name': 'widgets', 'active': false, 'hasBinding': false },
    'existing': { 'name': 'existing', 'active': false, 'hasBinding': false }
  };
  variableConstants = VARIABLE_CONSTANTS;
  variableService: any;
  activeDataSourceTab: any;
  validation: any = {};
  metadataFilter: any;
  nodeType: string;
  activeNodeType: string;
  selectedNode: any;
  disableBind: boolean;
  selectedNodeProps: any;
  sampleParamsValues: any = {};
  typeService: any;
  dataTypes: any;
  liveVariableService: any;
  pageWsService: PageWsService;
  isPrismWeb: boolean;

  private isNativeMobileApplicationType: boolean;
  private isMobileApplicationType: boolean;
  private platformType: string;

  constructor() {
    super();
    this.widgetPropertiesProvider = inject(WidgetPropertiesProvider);
    this.markupManagerService = inject(MarkupManagerService);
    this.apiService = inject(ApisService);
    this.webService = inject(WebserviceService);
    this.serviceFactory = inject(ServiceFactoryService);
    this.databaseService = inject(DatabaseService);
    this.treeService = inject(BindTreeUtilsService);
    this.variableService = inject(BaseVariableService);
    this.typeService = inject(TypeFactoryService);
    this.projectService = inject(ProjectService);
    this.liveVariableService = inject(WmsLiveVariableService);
    this.pageWsService = inject(PageWsService);
    this.isNativeMobileApplicationType = this.projectService.isNativeMobileApplicationType();
    this.isMobileApplicationType = this.projectService.isMobileApplicationType();
    this.platformType = this.projectService.getDetails().platformType;
    this.isPrismWeb = this.projectService.isPrismWeb();
  }

  ngOnInit(): void {
    const { requireVariable, screens } = this.widgetInfo;
    this.steps = [...screens];

    if (requireVariable) {
      this.steps.unshift({
        "label": "Data",
        "labelKey": "LABEL_DATA",
        "id": "select-data-source",
        "screen": "selectDataSource",
        "description": "MESSAGE_WIDGET_SELECT_DATASOURCE"
      })
    }
    this.showServiceSpinner = true;
    (this.serviceFactory.getServicesWithType(this.widgetDetails.reloadServices) as Promise<any>).then((services: any) => {
      this.showServiceSpinner = false;
      if (this.widgetType === 'wm-liveform' || this.widgetType === 'wm-livefilter') {
        this.dataSource = filter(services, (service) => {
          return service.type === VARIABLE_CONSTANTS.SERVICE_TYPE_DATA && service.type !== VARIABLE_CONSTANTS.SERVICE_TYPE_MODEL;
        }) || [];
      } else {
        this.dataSource = filter(services, (service) => {
          return service.type !== VARIABLE_CONSTANTS.SERVICE_TYPE_SECURITY && service.type !== VARIABLE_CONSTANTS.SERVICE_TYPE_MODEL;
        });
      }

      forEach(this.dataSource, (service: any) => {
        service.serviceType = this.variableServiceTypeMap[service.type];
        service.displayType = this.locale['SERVICE_NAME'][toUpper(service.type)];
      });

      if (this.projectService.isNativeMobileApplicationType()) {
        this.dataSource = filter(this.dataSource, (service) => {
          return service.serviceType !== 'openapi';
        });
      }

      this.filterDataSource('all');
    }).catch(() => this.showServiceSpinner = false);
    this.formConfig = this.widgetPropertiesProvider.getConfig('wm-form');
    this.liveformConfig = this.widgetPropertiesProvider.getConfig('wm-liveform');
    this.gridConfig = this.widgetPropertiesProvider.getConfig('wm-table');
    this.livelistConfig = this.widgetPropertiesProvider.getConfig('wm-list');
    this.filterConfig = this.widgetPropertiesProvider.getConfig('wm-livefilter');

    this.liveWidget = this.widgetDetails?.widgetType.split('-').join('.');
    this.widgetProperties = PropertiesFactory.getPropertiesOf(this.liveWidget);
    //Card doesn't have dataset which uses list flow
    if (this.widgetType === 'wm-card') {
      this.widgetProperties = { 'dataset': { 'type': 'array, object', 'bindable': 'in-bound', 'widget': 'string' } };
    }
    this.serviceTypes = getServiceTypesByCollectionType('data');
    this.filterServiceTypes(this.serviceTypeList);
    forEach(this.serviceTypes, (type) => {
      if (includes(this.serviceTypeList, type)) {
        this.categoryFilterList[type] = this.locale.LABEL_VARIABLE_SERVICETYPE[type];
      }
    });
  }

  ngAfterViewInit() {
    // Adding settimeout so that the ng-templates for different steps are loaded by then in the view child
    setTimeout(() => this.incrementStep(), 0);
  }

  getStepTemplate() {
    switch (this.currentStep?.screen) {
      case 'selectDataSource': return this.selectDataSourceStep;
      case 'templateConfig': return this.templateConfigStep;
      case 'liveListFieldConfig': return this.liveListFieldConfigStep;
      default: return this.emptyTemplate;
    }
  }

  incrementStep(): void {
    if (this.currentStep && this.currentStep.screen === 'templateConfig') {
       if (this.activeInnerStep !== 'pagination') {
        if (!this.isNativeMobileApplicationType && includes(['wm-table', 'wm-list', 'wm-card'], this.activeLiveWidget)) {
          this.selectStep('pagination');
          return;
        }
      } else {
        this.selectStep('layout');
      }
    }

      this.stepCounter += 1;
      this.onStepChange(this.stepCounter);

  }

  decrementStep(): void {
    if (this.currentStep && this.currentStep.screen === 'templateConfig' && this.activeInnerStep !== 'layout') {
      if (includes(['wm-table', 'wm-list', 'wm-card'], this.activeLiveWidget)) {
        this.selectStep('layout');
        return;
      }
    }
    this.stepCounter -= 1;
    this.onStepChange(this.stepCounter, true);
  }

  onStepChange(stepCount: number, isDecrement: boolean = false) {
    let prevStep = this.steps[stepCount - 1],
      liveListTemplate,
      templateObj: any,
      flatListMarkup = '',
      dataNode,
      stepDesc,
      fieldName: string,
      fields;

    this.currentStep = this.steps[stepCount];
    this.message = undefined;
    if (stepCount < this.steps.length) {
      this.nextBtnText = stepCount === (this.steps.length - 1) ? this.locale.LABEL_DONE : this.locale.LABEL_NEXT;
      //Active widget is set to dropped widget or to the configured widget within live widget
      this.activeLiveWidget = (this.widgetType === 'wm-list' && this.stepCounter > 1) || (this.widgetType === 'wm-livetable' && this.stepCounter > 0) || (this.widgetType === 'wm-table' && this.stepCounter > 1) ? this.currentStep.liveWidgetId : this.widgetType;
      //Get description of steps for steps
      if ((['selectDataSource', 'templateConfig'].includes(this.currentStep.screen)) || this.steps.length === 1) {
        this.stepDescription = this.locale[this.currentStep.description];
      }
      else {
        if (this.widgetConfig.bindMode) {
          dataNode = (this.widgetConfig.bindMode === 'variable' || this.widgetConfig.bindMode === 'existing') ? this.variableFilter?.name : this.widgetFilter?.name;
          stepDesc = this.activeLiveWidget === 'wm-list' ? 'MESSAGE_WIDGET_MAP_FIELDS' : this.widgetType === 'wm-form' ? 'MESSAGE_TEMPLATE_MAP_FIELDS_FORM' : 'MESSAGE_TEMPLATE_MAP_FIELDS';
          this.stepDescription = replace(this.locale[stepDesc], [this.widgetConfig.bindMode, dataNode, this.selectedLiveWidgetLayout.title]);
        }
      }
    }
    /* If previous step found, perform computations on previous steps.
     * the UI for previous step will be replaced with next step, hence respective controller will be destroyed
     * so, for prev step, required computations are done and configs persisted before controller is lost
     */
    if (prevStep && !isDecrement) {
      liveListTemplate = this.selectedLiveWidgetLayout?.template;
      templateObj = "" + liveListTemplate;
      let parsedTemplateObj = new DOMParser().parseFromString(templateObj, 'text/html');
      let listEle = parsedTemplateObj.querySelector("wm-list");
      switch (prevStep.screen) {
        // case 'widgetFieldTree':
        // case 'widgetFieldConfig':
        //   this.widgetDefs.fieldDefs = this.getConfiguredDefs(prevStep.columns).fieldDefs;
        //   stepCount >= this.steps.length && this.setLiveWidgetTemplate(prevStep);
        //   break;

        case 'templateConfig':
          if (this.widgetType === 'wm-form' || (this.widgetType === 'wm-table' && this.steps[0].dynamicWidget)) {
            this.hasBinding = false;
            this.widgetConfig.bindMode = '';
          }
          this.submitInProgress = false;
          dataNode = this.widgetConfig.bindMode && ((this.widgetConfig.bindMode === 'variable' || this.widgetConfig.bindMode === 'existing') ? this.variableFilter?.name : this.widgetFilter?.name);
          if (includes(['wm-list', 'wm-card'], this.activeLiveWidget)) {
            if (this.widgetType === 'wm-livetable') {
              this.fields = this.getFields();
            }
            this.listTemplate = this.widgetType === 'wm-livetable' && this.stepCounter > 1 ? this.steps[1].activeLayout : this.selectedLiveWidgetLayout;

            if (this.selectedLiveWidgetLayout.id === 'blank-card') {
              this.addNameAttribute(listEle, 'List');
              listEle?.setAttribute('dataset', this.activeWidgetScope.binddataset);
              listEle?.setAttribute('navigation', this.liveWidgetNavigation.selectedNavigation.id || 'None');
              this.widgetDefs.template = listEle;

              if (this.widgetType === 'wm-card' && this.selectedLiveWidgetLayout?.id === 'blank-card') {
                this.onSubmit();
                return;
              }
            }

            if (includes(['default', 'device-default'], this.selectedLiveWidgetLayout.id)) {
              if (this.fields.length) {
                let widgetEl = parsedTemplateObj.querySelector('wm-gridrow');
                forEach(this.fields, (field, index: number) => {
                  if (index < 11) {
                    fieldName = '';
                    fields = field.split('.');
                    each(fields, (name) => {
                      fieldName += includes(name, ' ') ? "['" + name + "']" : '.' + name;
                    });
                    flatListMarkup += '<wm-gridcolumn class="col-xs-6" columnwidth="1"><wm-label width="100%" caption="' + this.activeWidgetScope.binddataset + fieldName + '"></wm-label></wm-gridcolumn>';
                  }
                });
                if (this.widgetType === 'wm-livetable') {
                  flatListMarkup += '<wm-gridcolumn class="col-xs-6" columnwidth="1"><wm-anchor caption="" class="edit-list-item" iconclass="fa fa-pencil" show="false" margin="0 10px 0 0"></wm-anchor>' +
                    '<wm-anchor caption="" class="delete-list-item" iconclass="wi wi-trash" show="false"></wm-anchor></wm-gridcolumn>';
                }
                if (widgetEl) { widgetEl.innerHTML = flatListMarkup; }
              } else {
                //If there are no fields remove the grid layout from the default template of live list
                parsedTemplateObj.querySelector('wm-listtemplate');
              }
              this.addNameAttribute(listEle, 'List');
              listEle?.setAttribute("dataset", this.activeWidgetScope.binddataset);
              listEle?.setAttribute('navigation', this.liveWidgetNavigation.selectedNavigation.id || 'None');
              this.widgetDefs.template = listEle;
              //If widget type is livelist and its default template there won't be more steps
              if (this.widgetType === 'wm-list') {
                this.onSubmit();
                return;
              }
              //Default layout won't have mapping screen so increment step
              this.currentStep.template = listEle;
              this.incrementStep();
            }
          } else if (this.widgetConfig.bindMode && this.currentStep.screen !== 'templateConfig') {
            this.stepDescription = replace(this.locale.MESSAGE_TEMPLATE_MAP_FIELDS, [this.widgetConfig.bindMode, dataNode, this.selectedLiveWidgetLayout.title]);
          }
          // if (this.widgetType === 'wm-carousel' || this.steps[0].dynamicWidget) {
          //   this.setLiveWidgetTemplate(prevStep);
          // }
          break;
        case "liveListFieldConfig":
          if (!includes(['default', 'device-default'], this.selectedLiveWidgetLayout.id) || !includes(['default', 'device-default'], this.listTemplate.id)) {

            forEach(this.templateWidgets, (widget) => {
              let widgetEl = parsedTemplateObj.querySelector('[name="' + widget.name + '"]');

              parsedTemplateObj.querySelector('[aspect-ratio]')?.removeAttribute('aspect-ratio');
              forEach(widget.widgetProps, (prop) => {
                //If label widget and prop is caption and it is not mapped to any field, map it with its name
                if (widget.type === 'wm-label' && prop.name === 'caption' && !prop.value) {
                  prop.value = widget.name;
                }

                widgetEl?.setAttribute(prop.name, prop.value);
              });
            });
            this.addNameAttribute(listEle, 'List');
            listEle?.setAttribute("dataset", this.activeWidgetScope.binddataset);
            listEle?.setAttribute('navigation', this.liveWidgetNavigation.selectedNavigation.id || 'None');
            if (this.liveWidgetNavigation.selectedNavigation.id === NAVIGATION_TYPE.ONDEMAND) {
              listEle?.setAttribute('paginationclass', 'btn-default');
            }
            //For Db widget don't assign template to widgetDef
            if (this.widgetType === 'wm-livetable') {
              prevStep.template = listEle;
            } else {
              this.widgetDefs.template = listEle;
            }
          }
          break;
      }
    }

    /* if final step reached, submit the configurations */
    if (stepCount >= this.steps.length) {
      if (!this.submitInProgress) {
        this.submitInProgress = true;
        this.onSubmit();
      }
      return;
    }

    switch (this.currentStep.screen) {
      case 'selectDataSource':
        if (this.widgetDetails.activeLayout) {
          this.widgetDetails.activeLayout = null;
          this.resetSteps(this.gridConfig.screens);
        }
        this.initVariableDependencies();
        this.initWidgetDependencies();
        break;
      case 'templateConfig':
        // if (this.widgetType === 'wm-form') {
        //     this.hasBinding = true;
        //     this.widgetConfig.bindMode = this.isSourceMode ? 'variable' : 'existing';
        //     if (this.metadataFilter) {
        //         this.root.$emit('bind-widget-to-variable', this.metadataFilter.name, true, this.root.domScope);
        //     }
        // } else
        if (this.widgetConfig.bindMode !== 'widget' && this.hasBinding) {
          //$s is mandatory parameter, without $s data is saving in variables.json
          this.serviceName = this.variableFilter?.tableName;
          // TODO: check how to emit values to root
          // this.root.$emit('bind-widget-to-variable', this.variableFilter?.name, true, this.root.domScope);
        }
        if (this.activeLiveWidget === 'wm-liveform' || this.activeLiveWidget === 'wm-livefilter' || this.widgetType === 'wm-form' || (this.activeLiveWidget === 'wm-form' && this.widgetType === 'wm-table') || (this.activeLiveWidget === 'wm-form' && this.widgetType === 'wm-list')) {
          this.currentStep.captionAlign = this.currentStep.captionAlign || 'left';
          this.currentStep.captionPosition = this.currentStep.captionPosition || 'top';
        }
        //Add filter to grid based on the variable type
        let tableCallback = (isCrud?: boolean, crudOpId?: any) => {
          if (this.activeLiveWidget === 'wm-table') {
            this.gridOptions.isEditable = (this.variableFilter && (this.variableFilter.category === 'wm.LiveVariable') && !this.steps[0].dynamicWidget) || (this.widgetConfig.bindMode === 'widget') ? 'true' : 'false';
          } else {
            this.gridOptions.isEditable = undefined;
          }
          if (isCrud) {
            let createOrUpdateOps = this.operationsList.filter((op: any) => {
              return crudOpId === op.crudOperationId && (op.operationType === 'create' || op.operationType === 'update');
            });
            if (this.activeLiveWidget === 'wm-form' && this.widgetType !== 'wm-table') {
              if (!createOrUpdateOps.length) {
                this.alertMessages = {
                  'show': true,
                  'type': 'error',
                  'caption': this.locale.MESSAGE_POST_METHODS_NOT_FOUND
                };
                this.decrementStep();
                return false;
              }
            } else {
              if (createOrUpdateOps.length) {
                this.gridOptions.isEditable = 'true';
                this.gridOptions.canEdit = true;
              } else {
                this.gridOptions.isEditable = 'false';
                this.gridOptions.canEdit = false;
              }
              this.gridOptions.isEditable = this.platformType === 'MOBILE' ? undefined : this.gridOptions.isEditable;
            }
          }
          this.initLiveWidgetLayoutDependencies();
          //Select Inner step for grid and livelist
          if (includes(['wm-table', 'wm-list', 'wm-card'], this.activeLiveWidget)) {
            this.selectStep('layout');
          }
          return;
        };
        if ((this.variableFilter && this.variableFilter.category === 'wm.CrudVariable' && (this.activeLiveWidget === 'wm-table' || (this.activeLiveWidget === 'wm-form' && this.widgetType != 'wm-table') || (this.activeLiveWidget === 'wm-list' && this.platformType === 'MOBILE'))) || (get(this.widgetFilter, 'variable.category') === 'wm.CrudVariable') && this.activeLiveWidget === 'wm-table') {
          this.operationsList = this.operationsList || [];
          let crudOpId = this.variableFilter ? this.variableFilter.crudOperationId : get(this.widgetFilter, 'variable.crudOperationId');
          let service = this.variableFilter ? this.variableFilter.service : get(this.widgetFilter, 'variable.service');
          let currentOp = this.operationsList.filter((op: any) => {
            return crudOpId === op.crudOperationId
          });
          if (currentOp.length === 0) {
            this.showSpinner = true;
            this.serviceFactory.getServiceOperations(service).then((operations: any) => {
              this.showSpinner = false;
              this.operationsList = operations;
              tableCallback(true, crudOpId);
            }).catch((error: any) => { this.showSpinner = false; console.log('error in fetching services', error) });
          } else {
            tableCallback(true, crudOpId);
          }
        } else {
          tableCallback();
        }
        break;
      case 'liveListFieldConfig':
        //If step decrement and active widget is livelist with default template doesn't have field map step hence decrement step
        if (isDecrement && this.activeLiveWidget === 'wm-list' && includes(['default', 'device-default'], prevStep.activeLayout.id)) {
          this.decrementStep();
        } else {
          this.selectWidgetLayout(this.listTemplate);
          this.listImage = this.activeLiveWidget + '/' + this.listTemplate.id + (this.isPrismWeb ? '/screenshot-web.png' :'/screenshot.png');
        }
        break;
    }

    this.showWizard = this.steps.length > 1;
  }

  //Returns the fields based on variable type
  getFields(dataType?: any) {
    //Returns variable return type based on it's type
    function getVariableType(variableFilter: any) {
      //Package incase of Live variable and type incase of service variable
      switch (variableFilter.category) {
        case 'wm.LiveVariable':
          return variableFilter.package;
        case 'wm.CrudVariable':
        case 'wm.WebSocketVariable':
        case 'wm.ServiceVariable':
          return variableFilter.type;
        default:
          return null;
      }
    }
    let options = { 'getFieldInfo': true, 'filter': 'terminal' };
    dataType = dataType || getVariableType(this.variableFilter);

    // check whether the current datatype is exist in rootscope datatypes(this.root.dataTypes) or not
    if (dataType && get(this.typeService.getTypes(), dataType)) {
      return this.typeService.getFieldsForType(dataType, options);
    }
    // In case of static variable
    return this.typeService.getFieldsForExpr(this.activeWidgetScope.binddataset, options);
  }

  filterTemplates(templates: any) {
    let curPlatform = this.platformType === 'DEFAULT' ? 'WEB' : this.platformType;
    if (templates) {
      remove(templates, (template: any) => {
        // remove the template from the list if its platform type does not match with project platform type
        if (!includes(template.platform, curPlatform)) {
          return true;
        }
        if (this.widgetType != 'wm-list' && this.activeLiveWidget === 'wm-form') {
          if (includes(template.id, 'dialog-form')) {
            return true;
          }
        }
        if (this.widgetType === 'wm-livetable') {
          if (this.activeLiveWidget === 'wm-list') {
            //Include templates prefixed with 'device-'
            if (!includes(template.id, 'device-')) {
              return true;
            }
          } else if (this.activeLiveWidget === 'wm-liveform' && curPlatform === 'MOBILE') {
            return template.id !== 'dialog-form';
          }
        }
        if (this.widgetType === 'wm-liveform' && curPlatform === 'MOBILE') {
          return !includes(['mobile-inline', 'mobile-page'], template.id);
        }
        if (this.widgetType === 'wm-list') {
          if ((this.activeLiveWidget === 'wm-liveform' || this.activeLiveWidget === 'wm-form') && curPlatform === 'MOBILE') {
            return template.id !== 'dialog-form';
          }
          //Don't include templates prefixed with 'device-'
          if (includes(template.id, 'device-')) {
            return true;
          }

          if ((this.widgetConfig.bindMode === 'variable' || this.widgetConfig.bindMode === 'existing') && this.variableFilter && this.variableFilter.category !== 'wm.LiveVariable' && this.variableFilter.category !== 'wm.CrudVariable' || (this.variableFilter && this.variableFilter.category === 'wm.CrudVariable' && !this.gridOptions.canEdit)) {
            return template.id === 'list-form-device';
          }
        }

        return false;
      });
    }
    console.log(templates)
    return templates;
  }

  // TODO: add Variables dependencies
  //Initialize the variables for select data source screen.
  initVariableDependencies() {
    /* create a list containing option for showing all variables of all categories */
    let variableList: any = this.variableService.getStudioCopy();
    variableList = extend({}, variableList['App'], variableList[this.pageWsService.activePageName]);
    this.variableList = values(variableList);
    if (this.widgetType === 'wm-form') {
      this.metadataVariableList = filter(this.variableList, (variable) => {
        return variable.category !== 'wm.NavigationVariable' && variable.category !== 'wm.NotificationVariable';
      });
    }
    this.variableList = filter(this.variableList, (variable) => {
      //Live form we only support live variables.
      if (!(this.widgetType === 'wm-liveform' || this.widgetType === 'wm-livefilter')) {
        //For form include service variables of type post delete and get and all static variables
        if (this.widgetType === 'wm-form') {
          return variable.category === 'wm.Variable' || variable.category === 'wm.ServiceVariable' || variable.category === 'wm.CrudVariable';
        }
      } else {
        return variable.category === 'wm.LiveVariable';
      }
      return variable.category !== 'wm.NavigationVariable' && variable.category !== 'wm.NotificationVariable';
    });
    if (this.variableFilter && ((this.widgetType === 'wm-form' && this.variableFilter.category === 'wm.Variable') || this.widgetType !== 'wm-form')) {
      this.updateBindMapTree(this.variableFilter, true, this.isSourceMode);
    }
    //Function to get filtered options
    this.getFilteredOptions = StudioUtils.getFilteredOptions.bind(undefined, this.variableList);

  }

  //Initialize the widgets for select data source screen.
  initWidgetDependencies() {
    if (!this.widgetFilter) {
      let widgetList = byType('form-widgets');
      this.widgetList = pickBy(widgetList, (widget) => {
        //For liveform only allows widgets those are binded to variable of type LiveVariable
        if ((this.widgetType === 'wm-liveform' && widget.variableType === 'wm.LiveVariable') || (this.widgetType !== 'wm-liveform')) {
          return includes(this.widgetDetails.configOptions.bindTypes, widget.widgetType);
        }

        return false;
      });
    }
    this.widgetsAvailable = Object.keys(this.widgetList).length;
  }

  /*Initializes live widget dependencies based on the template and datasource selection*/
  initLiveWidgetDependencies() {
    // let variable,
    //   isBoundToVariable = this.widgetConfig.bindMode === 'variable' || this.widgetConfig.bindMode === 'existing',
    //   isBoundToWidget = this.widgetConfig.bindMode === 'widget',
    //   isParentBoundToLiveVariable,
    //   liveWidgetVariable: any;

    // this.showSpinner = true;
    // //If there are no fields populate with default fields
    // if ((this.fields && !this.fields.length)) {
    //   this.dataNode = { 'column1': '', 'column2': '', 'column3': '', 'column4': '', 'column5': '' };
    // }
    // if (this.activeLiveWidget === 'wm-liveform' || this.activeLiveWidget === 'wm-livefilter' || widgetType === 'wm-form' || (this.activeLiveWidget === 'wm-form' && widgetType === 'wm-table') || (this.activeLiveWidget === 'wm-form' && widgetType === 'wm-list')) {
    //   this.fieldTypeWidgetTypeMap = LiveWidgetUtils.getFieldTypeWidgetTypesMap();
    //   forEach(this.fieldTypeWidgetTypeMap, function (types, fieldType) {
    //     this.otherWdgts[fieldType] = filter(this.fieldTypeWidgetTypeMap.custom, function (widget) {
    //       return !includes(types, widget);
    //     });
    //   });
    // }
    // if (isBoundToVariable) {
    //   variable = this.isSourceMode ? this.variableFilter : Variables.getVariableByName(getVariable());
    // }

    // if (isBoundToWidget) {
    //   isParentBoundToLiveVariable = _.get(this.widgetFilter, ['Variables', Utils.getVariableName(this.widgetFilter), 'category']) === 'wm.LiveVariable';
    // }

    // //If primary source is a live entity then create a dummy liva variable and fetch propertiesMap for the same
    // if ((isBoundToVariable && variable.category === 'wm.LiveVariable') || (isBoundToWidget && isParentBoundToLiveVariable)) {
    //   if (isBoundToChildNode(this.activeWidgetScope.binddataset)) {
    //     let liveSource = isBoundToVariable ? this.variableFilter.liveSource : _.get(this.widgetFilter, ['variable', 'liveSource']);
    //     liveWidgetVariable = { 'name': 'variable1', 'liveSource': liveSource, 'type': this.nodeType };
    //     this.liveVariableService.getTableMetaData(this.root.project.id, liveWidgetVariable, undefined, undefined, function () {
    //       this.showSpinner = false;
    //       setComponentDefnObj(liveWidgetVariable);
    //     }, function () {
    //       this.showSpinner = false;
    //     });
    //   } else {
    //     liveWidgetVariable = isBoundToVariable ? variable : Widgets[this.widgetFilter.name].dataset;
    //     this.showSpinner = false;
    //   }
    // } else {
    //   this.showSpinner = false;
    //   liveWidgetVariable = this.fields;
    // }
    // if (widgetType !== 'wm-form' && !this.showSpinner) {
    //   setComponentDefnObj(liveWidgetVariable);
    // }
  }

  initLiveWidgetLayoutDependencies() {
    let layout,
      defaultLayout,
      variableCategory = (this.widgetConfig?.bindMode === 'variable' || this.widgetConfig?.bindMode === 'existing') ? (this.variableFilter && this.variableFilter?.category) : undefined,
      readOnlyVariableTypes = ['wm.WebSocketVariable', 'wm.ServiceVariable', 'wm.CrudVariable', 'wm.Variable'],
      isActiveLayoutExists = (layout: any) => {
        let layouts = this.liveWidgetLayouts.filter((obj: any) => {
          return obj.id === layout.id;
        });
        return layouts && layouts[0];
      };
    this.liveWidgetLayouts = [...this.currentStep.templates];
    if ((variableCategory === 'wm.CrudVariable' && this.activeLiveWidget === 'wm-table') || (get(this.widgetFilter, 'variable.category') === 'wm.CrudVariable' && this.activeLiveWidget === 'wm-table')) {
      this.liveWidgetLayouts = this.currentStep.templates.filter((template: any) => {
        return template.id.indexOf('crud') > -1 || (!template.isEditable && template.id != 'grid-form-readonly');
      });
    } else if (this.activeLiveWidget === 'wm-table') {
      this.liveWidgetLayouts = this.currentStep.templates.filter((template: any) => {
        return template.id.indexOf('crud') < 0;
      });
    }
    this.liveWidgetLayouts = cloneDeep(this.filterTemplates(this.liveWidgetLayouts));
    //If bind mode is variable and variable is of type service variable/static variable and widget is grid then remove editable grid from templates
    if (variableCategory != 'wm.CrudVariable' || (variableCategory === 'wm.CrudVariable' && !this.gridOptions.canEdit)) {
      if (this.hasBinding && this.widgetType === 'wm-table' && (this.steps[0].dynamicWidget || includes(readOnlyVariableTypes, variableCategory))) {
        this.liveWidgetLayouts = filter(this.liveWidgetLayouts, (layout: any) => {
          return layout.id === 'readonly-grid' || (variableCategory === 'wm.Variable' && (layout.id === 'editable-grid' || layout.id === 'quick-inline-editable'));
        });
      }
    }

    /* select active layout */
    if (this.hasBinding && ((this.widgetType !== 'wm-livetable' || this.widgetType !== 'wm-table') && this.widgetDetails?.activeLayout) && (((this.widgetType === 'wm-livetable' && this.stepCounter < 1) || (this.stepCounter < 2 && this.widgetType === 'wm-table')) && this.widgetDetails.activeLayout)) {
      layout = this.widgetDetails.activeLayout;
    } else {
      if (this.widgetType === 'wm-livetable' && this.activeLiveWidget === 'wm-livefilter') { //If widget is livetable and active widget is filter make two-column template as default
        defaultLayout = this.liveWidgetLayouts[1];
      } else if (this.activeLiveWidget === 'wm-table') { //If data source is live variable make 'grid-form' template as default template
        this.setGridTemplates(this.gridOptions.isEditable);
      } else if (this.activeLiveWidget === 'wm-liveform') { //If widget is liveform set 2 column layout as default
        defaultLayout = this.isMobileApplicationType ? this.liveWidgetLayouts[0] : this.liveWidgetLayouts[2];
      } else {
        defaultLayout = this.liveWidgetLayouts[0];
      }
      layout = this.currentStep.activeLayout || defaultLayout;
    }

    if (this.widgetType === 'wm-list' && !isActiveLayoutExists(layout)) {
      layout = this.liveWidgetLayouts[0];
    }

    this.selectWidgetLayout(layout);
  }

  //Change inner step
  selectStep(innerStepName: any) {
    this.activeInnerStep = innerStepName;
    if ((['wm-list', 'wm-card']).includes(this.activeLiveWidget)) {
      this.navigationList = this.listNavigations;
      this.nextBtnText = this.activeInnerStep === 'pagination' && (this.selectedLiveWidgetLayout?.id === 'default' || this.selectedLiveWidgetLayout?.id === 'blank-card') ? this.locale.LABEL_DONE : this.locale.LABEL_NEXT;
    } else {
      this.navigationList = this.gridNavigations;
      this.nextBtnText = this.steps[0].dynamicWidget && this.activeInnerStep === 'pagination' ? this.locale.LABEL_DONE : this.locale.LABEL_NEXT;
    }
    //Select default navigation if none
    if (!this.liveWidgetNavigation?.selectedNavigation) {
      this.liveWidgetNavigation = { selectedNavigation: '' };
      this.liveWidgetNavigation.selectedNavigation = this.widgetType === 'wm-list' && this.isMobileApplicationType ? this.navigationList[1] : this.navigationList[0];
    }
  }

  // Set grid templates on change of toggle value
  setGridTemplates(val: any) {
    this.gridOptions.isEditable = val;
    this.selectWidgetLayout(find(this.liveWidgetLayouts, { id: (val === 'true' || val === true ? (this.variableFilter && this.variableFilter.category === 'wm.Variable' ? 'editable-grid' : ((this.variableFilter && this.variableFilter.category === 'wm.CrudVariable' && this.gridOptions.canEdit) || (get(this.widgetFilter, 'variable.category') === 'wm.CrudVariable' && this.gridOptions.canEdit) ? 'crud-grid-form-dialog' : 'grid-form-dialog')) : 'readonly-grid') }))
  }

  selectWidgetLayout(layout: any) {
    layout.active = true;
    //For live widget we keep track of selected layout within currentStep
    if (!((this.widgetType === 'wm-livetable' && this.stepCounter > 0) || (this.widgetType === 'wm-table' && this.stepCounter > 1))) {
      this.widgetDetails.activeLayout = layout;
    }
    if ((this.widgetType === 'wm-livetable' && this.stepCounter === 0) || (this.widgetType === 'wm-table' && this.stepCounter === 1)) {
      this.resetLiveWidgetSteps();
      this.nextBtnText = this.stepCounter === (this.steps.length - 1) ? this.locale.LABEL_DONE : this.locale.LABEL_NEXT;
    } else if (this.widgetType === 'wm-carousel') {
      this.hasBinding = true;
    }
    if (this.activeLiveWidget === 'wm-list') {
      this.steps = this.steps.splice(0, 3);
      if (layout.id === 'list-form-device') {
        if (this.variableFilter && this.variableFilter.category === 'wm.CrudVariable') {
          this.steps = this.steps.concat(this.formConfig.screens);
        } else {
          this.steps = this.steps.concat(this.liveformConfig.screens);
        }
      }
    }

    this.currentStep.activeLayout = this.selectedLiveWidgetLayout = layout;
    processLiveWidgetTemplate(layout.template, this);

  }

  selectWidgetNavigation(navType: any) {
    this.liveWidgetNavigation.selectedNavigation = navType;
  }

  selectTemplateWidget(widget: any) {
    this.selectedWidget = widget;
  };

  resetLiveWidgetSteps() {
    if (this.widgetType === 'wm-form') {
      this.resetSteps(this.formConfig.screens); //Reset the screens with the original properties
      if (this.steps[0].dynamicWidget) { //If fields are dynamic, remove the last step (fields configuration step)
        this.steps.splice(this.steps.length - 1, 1);
      } else {
        this.steps.push(this.formConfig.screens[1]);
      }
      return;
    }
    //Remove the steps and concat according to new layout.
    if (this.widgetType === 'wm-livetable') {
      this.steps.splice(1, this.steps.length - 1);
    } else {
      this.steps.splice(3, this.steps.length - 1);
    }
    this.resetSteps(this.gridConfig.screens);
    this.resetSteps(this.liveformConfig.screens);
    this.resetSteps(this.filterConfig.screens);
    this.resetSteps(this.livelistConfig.screens);
    switch (this.widgetDetails.activeLayout.id) {
      case 'crud-grid-form':
      case 'crud-grid-form-readonly':
      case 'crud-grid-form-dialog':
        this.steps = this.steps.concat(this.formConfig.screens);
        break;
      case 'grid-form':
      case 'grid-form-readonly':
      case 'grid-form-dialog':
        this.steps = this.widgetType === 'wm-livetable' ? this.steps.concat(this.gridConfig.screens[1]).concat(this.liveformConfig.screens) : this.steps.concat(this.liveformConfig.screens);
        break;
      case 'grid-form-filter':
        this.steps = this.steps.concat(this.filterConfig.screens).concat(this.gridConfig.screens[1]).concat(this.liveformConfig.screens);
        break;
      case 'list-form-device':
      case 'list-form-web':
        this.steps = this.steps.concat(this.livelistConfig.screens).concat(this.liveformConfig.screens);
        break;
    }
  }

  resetSteps(steps: any) {
    steps?.forEach((step: any, index: number) => {
      //Don't reset if its decrement step and not fresh dnd of widget
      if (index === 0 && !this.selectedLiveWidgetLayout) {
        step.activeLayout = null;
        if (this.widgetType === 'wm-liveform' || this.widgetType === 'wm-livefilter') {
          step.captionAlign = 'left';
          step.captionPosition = 'top';
        }
      } else {
        if (this.activeLiveWidget !== 'wm-list') {
          step.columns = null;
          step.componentDefnObject = null;
          step.selectedComponent = null;
        }
      }
    });
  }

  addNameAttribute(element: any, widgetType: string) {
    let name = this.getUniqueWidgetName(widgetType);
    // add name attribute if the length of the name is 32 characters or less.
    if (name.length <= 32) {
      element?.setAttribute('name', name);
    }
  }

  /**
 * Generates a unique name for the widget based on the source selected in the dialog.
 * @param name : Widget type which will be a part of the name generated.
 * @returns {*} returns a name of the widget
 */
  getUniqueWidgetName(name: string) {
    name = this.markupManagerService.getUniqueIdByType(this.getSelectedSource() + name);
    name = specialCharactersToUnderscores(name);
    return getUniqueWidgetName(this.markupManagerService.getMarkup(), name);
  }

  /**
 * Finds the source variable/widget that is selected and return appropriate name.
 *  1) For RestService variables source name of the variable should be returned.
 * @returns {*|string}
 */
  getSelectedSource() {
    let variable;
    // return dataSourceName if already existed.
    if (this.dataSourceName) {
      return this.dataSourceName;
    }
    // If variable is selected as the data source.
    if (this.widgetConfig.bindMode === 'variable' || this.widgetConfig.bindMode === 'existing' || !this.widgetConfig.bindMode) {
      // If new varibale is created.
      if (this.isSourceMode) {
        // If data source is a RestType variable return service name.
        if (this.selectedDataSource?.source?.type === SERVICE_TYPE_REST) {
          this.dataSourceName = this.selectedDataSource?.source?.name;
        } else {
          this.dataSourceName = this.selectedDataSource?.operation?.name;
        }
      } else {
        this.dataSourceName = this.getSourceDataFromServiceVariable(this.variableFilter);
      }
    } else {
      // If Widget is selected as the data source.
      variable = this.widgetFilter.variable;
      if (variable) {
        this.dataSourceName = this.getSourceDataFromServiceVariable(variable);
      } else {
        this.dataSourceName = '';
      }
    }
    return this.dataSourceName;
  }

  /**
 * Appropriate name for the variable is returned for a widget.
 * @param variable : variable object.
 * @returns {string} appropriate name of variable for the widget will be returned.
 *
 */
  getSourceDataFromServiceVariable(variable: any) {
    let name = '';
    if (variable.category === 'wm.ServiceVariable' || variable.category === 'wm.CrudVariable') {
      // If varibale is a service type then  retun the service name else return the operation name.
      if (variable.serviceType === SERVICE_TYPE_REST) {
        name = variable.service;
      } else {
        name = variable.operation;
      }
    } else if (variable.category === 'wm.LiveVariable') {
      name = variable.type;
    } else {
      name = variable.name;
    }
    return name;
  }

  //Function to get configured defs of live widget
  getConfiguredDefs = (columns: any) => {
    let newFieldDefs: any = [];
    forEach(columns, (column, index) => {
      newFieldDefs[index] = {};
      newFieldDefs[index].title = column.title;
      newFieldDefs[index].fields = [];
      forEach(column.fields, (columnDef) => {
        /*push the columnDef only if one of target device is set to be displayed(pc/mobile)*/
        if ((columnDef.pcDisplay || columnDef.mobileDisplay || columnDef.tabletDisplay) && !columnDef.remove) {
          columnDef.pcDisplay = columnDef.pcDisplay || false;
          columnDef.tabletDisplay = columnDef.tabletDisplay || false;
          columnDef.mobileDisplay = columnDef.mobileDisplay || false;

          /*if width is given and a number set it*/
          if (columnDef.widthValue && !isNaN(columnDef.widthValue)) {
            columnDef.width = columnDef.widthValue + columnDef.widthUnit;
          } else if (!columnDef.widthValue || (!columnDef.widthValue.length && stringStartsWith(columnDef.width, columnDef.widthValue))) {
            /* Reset the width to default value when the widthValue is cleared from the UI. */
            columnDef.width = '*';
          }

          /*if binding is undefined remove it from column properties*/
          if (!columnDef.field) {
            delete columnDef.field;
          }
          columnDef.remove = undefined;
          newFieldDefs[index].fields.push(columnDef);
        }
      });
    });

    return {
      fieldDefs: newFieldDefs
    };
  };

  setCaptionAlign = (align: any) => {
    this.currentStep.captionAlign = align;
  };
  setCaptionPosition = (position: any) => {
    this.currentStep.captionPosition = position;
  };

  setWidgetProp = (prop: any) => {
    let fieldName = getFieldName(prop);
    prop.value = this.activeWidgetScope.binddataset + '[$i]' + fieldName;
    this.selectedWidget.hasBinding = true;
  };

  //Filter service type list based on widget
  filterServiceTypes(serviceTypeList: any) {
    let categoryFilterList = {};

    remove(serviceTypeList, (serviceType) => {
      if (this.widgetType === 'wm-form') {
        return serviceType === 'database'; //If form remove database service type
      } else if (includes(['wm-liveform', 'wm-livefilter'], this.widgetType)) {
        return serviceType !== 'database'; //If liveform or livefilter remove all types except database
      }
      if (this.isNativeMobileApplicationType) {
        return serviceType === 'openapi';
      }
      return;
    });

    //If live form remove all option.
    if (!includes(['wm-liveform', 'wm-livefilter'], this.widgetType)) {
      categoryFilterList = { 'all': this.locale.LABEL_INSERT_VARIABLE_FILTER_ALL };
    }

    this.categoryFilterList = categoryFilterList;
  }

  //Filter the data source based on selected service type
  filterDataSource = (filterBy: any) => {
    let filterQuery;
    this.showDesignButton = {};
    this.setActiveDataSourceTab();

    filterQuery = filterBy === 'databaseapi' ? 'database' : filterBy;

    this.filteredDataSources = filterQuery === 'all' ? this.dataSource : filter(cloneDeep(this.dataSource), { 'serviceType': filterQuery });

    if (!this.filteredDataSources.length) {
      this.showDesignButton[filterQuery] = true;
    }
  };

  setVariableCategoryFilter(val: any) {
    this.variableCategoryFilter = val;
    this.filterDataSource(this.variableCategoryFilter);
  }

  setActiveDataSourceTab(tab?: any) {
    if (tab) { this.widgetConfig.bindMode = tab; }
    this.variableFilter = null;
    this.widgetFilter = null;
    this.selectedDataSource = {
      source: null,
      operation: null,
      operations: [],
      startUpdate: null,
      maxResults: null,
      variableNameCreate: null
    }
    this.hasBinding = false;
    this.alertMessages = undefined;
    this.isSourceMode = this.widgetConfig?.bindMode === 'variable';
  }

  selectedSourceOperations(val: any) {
    console.log(val)
    let opController,
      dataSourceParams;
    this.selectedDataSource = {
      ...this.selectedDataSource,
      source: val,
      operations: [],
      maxResults: 20,
      dataLimit: 20,
      operation: ''
    }
    this.treeData = false;
    this.hasBinding = false;
    this.alertMessages = undefined;
    this.operationText = 'LABEL_SELECT_OPERATION_TYPE';

    if (this.selectedDataSource?.source?.type === VARIABLE_CONSTANTS.SERVICE_TYPE_REST) {
      this.showSpinner = true;
      (this.webService.getRESTDetails({
        urlParams: { 'projectID': this.projectService.getProjectId(), 'serviceID': this.selectedDataSource.source.name }
      }) as Promise<any>).then((response: any) => {
        this.showSpinner = false;
        if (response && response.httpRequestDetails) {
          forEach(response.httpRequestDetails.queryParams, (value, key) => {
            this.sampleParamsValues[key] = value;
          });
          forEach(response.httpRequestDetails.headers, (value, key) => {
            this.sampleParamsValues[key] = value;
          });
          if (response.httpRequestDetails.requestBody) {
            this.sampleParamsValues.RequestBody = response.httpRequestDetails.requestBody;
          }
        }
      }).catch(() => {
        this.showSpinner = false;
      });
    }
    if (this.selectedDataSource?.source?.type === VARIABLE_CONSTANTS.SERVICE_TYPE_DATA) {
      if (this.widgetType !== 'wm-form' && this.variableCategoryFilter !== 'databaseapi') {
        dataSourceParams = {
          'projectID': this.projectService.getProjectId(),
          'dataModelName': this.selectedDataSource.source.name
        };
        this.showSpinner = true;
        this.databaseService.getAllEntities(dataSourceParams).then((dataTables: any) => {
          this.showSpinner = false;
          dataTables = orderBy(dataTables, 'entityName', false);
          forEach(dataTables, (dataTable) => {
            this.selectedDataSource.operations.push({
              type: 'Entities',
              displayType: 'Entities',
              name: dataTable.entityName,
              serviceType: 'wm.LiveVariable'
            });
          });
          this.toggleMessage();
        }).catch(() => {
          this.showSpinner = false;
        });

        this.operationText = 'LABEL_SELECT_TABLE';
      } else if (!(this.widgetType === 'wm-liveform' || this.widgetType === 'wm-livefilter') && includes(['databaseapi', 'all'], this.variableCategoryFilter)) {
        this.showSpinner = true;
        this.serviceFactory.getServiceOperations(this.selectedDataSource.source.name).then((operations: any) => {
          this.showSpinner = false;
          operations = orderBy(operations, 'name');
          forEach(operations, (operation: any) => {
            opController = operation.controller ? operation.controller.replace(/Controller$/, '') : '';
            if ((includes(['QueryExecution', 'ProcedureExecution'], opController) && this.widgetType !== 'wm-form') || this.hasParams(operation)) {
              if (operation?.name !== 'executeWMCustomQuery' && operation.name !== 'executeWMCustomProcedure') {
                this.selectedDataSource.operations.push({
                  type: opController,
                  operationId: operation.operationId,
                  displayType: startCase(opController),
                  name: operation.name,
                  serviceType: 'wm.ServiceVariable'
                });
              }
            }
          });
          this.toggleMessage();
        }).catch((error: any) => { this.showSpinner = false; console.log('error in fetching services', error) });
      }

    }
    else if (this.selectedDataSource?.source?.type === VARIABLE_CONSTANTS.SERVICE_TYPE_WEBSOCKET) {
      this.showSpinner = true;
      this.selectedDataSource.dataUpdateStrategyOptions = { "refresh": "Refresh dataSet", "append": "Add as last record in dataSet", "prepend": "Add as first record in dataSet" };
      this.serviceFactory.getServiceOperations(this.selectedDataSource?.source?.name).then((operations: any) => {
        this.showSpinner = false;
        operations = orderBy(operations, 'name');
        forEach(operations, (operation: any) => {
          opController = operation.controller ? operation.controller.replace(/Controller$/, '') : '';
          this.selectedDataSource.operations.push({
            name: operation.name,
            operationId: operation.operationId,
            type: opController,
            serviceType: 'wm.WebSocketVariable'
          });
        });
        this.toggleMessage();
        this.selectedDataSource.operation = this.selectedDataSource.operations[0];
        this.enableNext();
      }).then((error: any) => { this.showSpinner = false; console.log('error in fetching services', error) });
    }
    else {
      this.showSpinner = true;
      this.serviceFactory.getServiceOperations(this.selectedDataSource?.source?.name).then((operations: any) => {
        // TODO: Add operationsList to rootScope
        // $rs.operationsList = operations;
        this.showSpinner = false;
        operations = orderBy(operations, 'name');
        let crudOperations: any = [], otherOperations: any = [];
        operations.forEach((op: any) => {
          if (op.entityName && op.operationType)
            crudOperations.push(op);
          else
            otherOperations.push(op);
        });
        let entities = groupBy(crudOperations, 'entityName'), listType, createOrUpdateType;
        let displayType = 'Endpoints';
        {
          for (let k in entities) {
            listType = entities[k].filter((filteredEntity) => {
              return filteredEntity.operationType === 'list'
            });
            createOrUpdateType = entities[k].filter((filteredEntity) => {
              return filteredEntity.operationType === 'create' || filteredEntity.operationType === 'update'
            });
            if ((this.widgetType === 'wm-form' && createOrUpdateType.length) || (this.widgetType !== 'wm-form' && listType.length)) {
              this.selectedDataSource.operations.push({
                name: k,
                operationId: k.replace(/Controller$/, ''),
                crudOperationId: entities[k][0].crudOperationId || k,
                type: entities[k][0].controller ? entities[k][0].controller.replace(/Controller$/, '') : '',
                serviceType: 'wm.CrudVariable',
                displayType: 'Entities',
              });
              displayType = 'Other Endpoints';
            }
          }
          forEach(otherOperations, (operation) => {
            opController = operation.controller ? operation.controller.replace(/Controller$/, '') : '';

            this.selectedDataSource.operations.push({
              name: operation.name,
              operationId: operation.operationId,
              type: opController,
              serviceType: 'wm.ServiceVariable',
              displayType: displayType,
            });
          });


          this.toggleMessage();

          this.operationText = 'LABEL_SELECT_OPERATION_TYPE';

          if (this.selectedDataSource.source.type === VARIABLE_CONSTANTS.SERVICE_TYPE_REST) {
            this.selectedDataSource.operation = this.selectedDataSource.operations[0];
            this.enableNext();
          }
        }
      }).catch((error: any) => { this.showSpinner = false; console.log('error in fetching services', error) });
    }
  }

  //function to check if operation has params
  hasParams(op: any) {
    //if other than get method then check if operation has params
    return op.operationType !== 'get' || some(op.parameter, (param) => {
      return !includes(VARIABLE_CONSTANTS.PAGINATION_PARAMS, param.name);
    });
  }

  onOperationClear() {
    this.variableFilter = null;
    this.alertMessages = undefined;
    this.templateWidgets = [];
  };

  enableNext() {
    this.alertMessages = undefined;
    this.templateWidgets = [];
    this.showSpinner = !!this.selectedDataSource.operation;//Showing spinner is operation is selected
    let optionObject: any;
    if (this.selectedDataSource.operation.serviceType === 'wm.LiveVariable') {
      this.selectedDataSource.startUpdate = true;
      this.selectedDataSource.autoUpdate = true;
      optionObject = {
        'liveSource': this.selectedDataSource.source.name,
        'type': this.selectedDataSource.operation.name,
        'category': this.selectedDataSource.operation.serviceType
      };
      this.selectedDataSource.variableNameCreate = initCaps(this.selectedDataSource.source.name) + initCaps(this.selectedDataSource.operation.name) + 'Data';
    } else if (this.selectedDataSource.operation.serviceType === 'wm.ServiceVariable') {
      this.selectedDataSource.startUpdate = false;
      this.selectedDataSource.autoUpdate = true;
      optionObject = {
        'service': this.selectedDataSource.source.name,
        'operation': this.selectedDataSource.operation.name,
        'operationId': this.selectedDataSource.operation.operationId,
        'category': this.selectedDataSource.operation.serviceType
      };
      this.selectedDataSource.variableNameCreate = initCaps(this.selectedDataSource.source.name) + initCaps(this.selectedDataSource.operation.name);
    } else if (this.selectedDataSource.operation.serviceType === 'wm.CrudVariable') {
      let listExists = this.checkCRUDOperationExists('list');
      if (!listExists || this.widgetType === 'wm-form') {
        this.selectedDataSource.startUpdate = false;
        this.selectedDataSource.autoUpdate = true;
      } else {
        this.selectedDataSource.startUpdate = true;
        this.selectedDataSource.autoUpdate = false;
      }
      optionObject = {
        'service': this.selectedDataSource.source.name,
        'operation': this.selectedDataSource.operation.operationId,
        'operationId': this.selectedDataSource.operation.operationId,
        'crudOperationId': this.selectedDataSource.operation.crudOperationId,
        'category': this.selectedDataSource.operation.serviceType
      };
      let name = initCaps(this.selectedDataSource.source.name) + initCaps(this.selectedDataSource.operation.name);
      name = specialCharactersToUnderscores(name);
      this.selectedDataSource.variableNameCreate = name;
    } else if (this.selectedDataSource.operation.serviceType === 'wm.WebSocketVariable') {
      this.selectedDataSource.startUpdate = true;
      optionObject = {
        'service': this.selectedDataSource.source.name,
        'operationId': this.selectedDataSource.operation.operationId,
        'category': this.selectedDataSource.operation.serviceType
      };
      this.selectedDataSource.variableNameCreate = initCaps(this.selectedDataSource.source.name);
    }

    this.variableFilter = this.variableService.createVariable(this.selectedDataSource.operation.serviceType, optionObject, this.selectedDataSource.variableNameCreate);
    this.selectedDataSource.variableNameCreate = this.variableFilter.name;

    if (this.selectedDataSource.operation.serviceType === 'wm.LiveVariable') {
      this.liveVariableService.__getTableMetaData(this.projectService.getProjectId(), this.variableFilter, undefined, undefined, () => {
        let variableObj = this.variableFilter;
        this.liveVariableService.__updateVariableDataset(variableObj, variableObj.data, variableObj.propertiesMap, variableObj.pagingOptions);
        this.updateBindMapTree(this.variableFilter, undefined, this.isSourceMode);
        this.showSpinner = false;
      }, () => {
        this.showSpinner = false;
      });
    } else if (this.selectedDataSource.operation.serviceType === 'wm.ServiceVariable' || this.selectedDataSource.operation.serviceType === 'wm.WebSocketVariable') {
      this.alertMessages = {
        caption: this.locale.MESSAGE_FOR_SERVICE_INPUT,
        show: true,
        type: 'info'
      };
      this.serviceFactory.getServiceOperationParams(this.variableFilter.service, this.variableFilter.operationId).then((response: any) => {
        this.variableFilter.isList = response.isList;
        this.variableFilter.type = response.return.typeRef;
        this.variableFilter.serviceType = this.serviceFactory.getServiceObjectByName(this.selectedDataSource.source.name).type;
        this.variableFilter.operationType = response.operationType;
        this.updateBindMapTree(this.variableFilter, undefined, this.isSourceMode);
        this.showSpinner = false;
      });
    } else if (this.selectedDataSource.operation.serviceType === 'wm.CrudVariable') {
      //this.selectedDataSource.operation.serviceType
      this.alertMessages = {
        caption: this.locale.MESSAGE_FOR_SERVICE_INPUT,
        show: true,
        type: 'info'
      };
      let opType = this.widgetType === 'wm-form' ? 'createorupdate' : 'list';
      this.serviceFactory.getCrudServiceOperationParams(this.variableFilter?.service, this.variableFilter?.crudOperationId, opType).then((response: any) => {
        this.variableFilter.isList = response.isList;
        /* For a CRUD Variable, the return type should always be the list return type so that when
        *a Data Table is created for existing Form CRUD Variable, we can show the correct properties.
       */
        let listOperation = filter(this.operationsList, (operation) => {
          return operation.crudOperationId === this.variableFilter.crudOperationId && operation.operationType === 'list';
        })[0];
        this.variableFilter.type = get(listOperation, 'return.typeRef') || response.return.typeRef;
        this.variableFilter.serviceType = this.serviceFactory.getServiceObjectByName(this.selectedDataSource.source.name).type;
        this.variableFilter.operationType = response.operationType;
        this.updateBindMapTree(this.variableFilter, undefined, this.isSourceMode);
        this.showSpinner = false;
      });
    }
    if (!this.selectedDataSource.operation) {
      this.treeData = false;
      this.hasBinding = false;
    }
  }

  setOperationForSelectedSource(op: any) {
    this.selectedDataSource.operation = op;
  }

  checkCRUDOperationExists(type: any) {
    let crudOpId = this.selectedDataSource && this.selectedDataSource.operation ? this.selectedDataSource.operation.crudOperationId : (this.variableFilter ? this.variableFilter.crudOperationId : get(this.widgetFilter, 'variable.crudOperationId'));
    let filteredList = filter(this.operationsList, (operation) => {
      return operation.crudOperationId === crudOpId && operation.operationType === type;
    });
    return filteredList.length;
  }

  updateGeneratedVariableName(val: string) {
    this.selectedDataSource.variableNameCreate = val;
    this.variableFilter.name = this.selectedDataSource.variableNameCreate = this.selectedDataSource.variableNameCreate.replace(/\s/g, '');
    this.updateBindMapTree(this.variableFilter, undefined, this.isSourceMode);
  };

  toggleMessage() {
    if (this.widgetType !== 'wm-form') {
      return false;
    }
    if (this.selectedDataSource.operations.length) {
      this.alertMessages = undefined;
    } else {
      this.alertMessages = {
        'show': true,
        'type': 'error',
        'caption': this.locale.MESSAGE_POST_METHODS_NOT_FOUND
      };
    }
    return
  }
  updateBindMapTree(bindNode: any, isPrevBound?: boolean, subMode?: any, metadata?: any) {
    let bindTreeConfig = {};
    let variableCollection = this.variableService.getStudioCopy();
    let variablesTree = this.treeService.getRootStructure(variableCollection);
    let widgetPropertiesTree;
    let widgetClass;
    this.variableFilter = null;
    let treeData = [];

    if (bindNode && bindNode.KEY  === 'WM_SOURCE') {
      this.setActiveDataSourceTab(this.widgetConfig.bindMode);
      this.isSourceMode = true;
      return;
    }
    this.validation = undefined;

    if (bindNode) {
      switch (this.widgetConfig.bindMode) {
        case 'existing':
        case 'variable':
          if (metadata) {
            this.metadataFilter = bindNode;
            this.activeWidgetScope.binddataset = 'bind:Variables.' + this.metadataFilter.name + '.dataSet';
          } else {
            this.variableFilter = bindNode;
            this.activeWidgetScope.binddataset = !isPrevBound ? 'bind:Variables.' + this.variableFilter.name + '.dataSet' : this.activeWidgetScope.binddataset;
            this.fields =  this.getFields(this.activeNodeType);
          }
          bindTreeConfig = { 'activePageName' : this.pageWsService.activePageName,
            'activeProperty' : {'name': 'dataset',
              'propertyDetails': {'bindable': "in-bound",
                'disabled': false,
                'show': true,
                'type': "array, object",
                'widget': "string"}},
            'bindMode': this.widgetConfig.bindMode, 'boundEntity' : this.activeWidgetScope.binddataset,
            'prevBoundEntity': this.activeWidgetScope.binddataset};
          this.treeService.setBindMapConfig(bindTreeConfig, (nodeId: string, nodeProps: any) => this.validateBinding(nodeId, nodeProps));
          if (!this.treeService.isCallVariable(bindNode.category)) {
            treeData.push({
              "id":  bindNode.name,
              "class": formatVariableIconClass(bindNode.category),
              "children": this.treeService.getTreeForVar(bindNode, true),
              "collapsed": false,
              "props": {
                "bindable": true,
                "value": bindNode.name,
                "type": "variable",
                "datatype": bindNode.category,
                "category": bindNode.category
              },
              "active": false
            });
          }
          break;
        case 'widget':
          this.widgetFilter = bindNode;
          bindTreeConfig = { 'activePageName' : this.pageWsService.activePageName,
            'activeProperty' : {'name': 'dataset',
              'propertyDetails': {'bindable': "in-bound",
                'disabled': false,
                'show': true,
                'type': "array, object",
                'widget': "string"}},
            'bindMode': this.widgetConfig.bindMode, 'boundEntity' : this.activeWidgetScope.binddataset,
            'prevBoundEntity': this.activeWidgetScope.binddataset};
          this.treeService.setBindMapConfig(bindTreeConfig, (nodeId: string, nodeProps: any) => this.validateBinding(nodeId, nodeProps));
          this.treeService.buildVariables(variableCollection, variablesTree);
          // get the constructed tree-like structure of out-boundable properties of the widget
          widgetPropertiesTree = this.treeService.getWidgetPropertiesChildTree(this.widgetFilter, null, variablesTree, undefined, undefined);
          //Make the first widget prop node active and expand by default
          if (widgetPropertiesTree && widgetPropertiesTree.length) {
            widgetPropertiesTree[0].active = true;
            this.handleTreeNodeClick({dataItem: {id: widgetPropertiesTree[0].id, props: widgetPropertiesTree[0].props}});
          }
          widgetClass = this.widgetFilter.widgettype === 'wm-chart' ;
          // Push the widget to the Widgets tree
          treeData.push({
            "id": this.widgetFilter.name,
            "class": widgetClass,
            "children": widgetPropertiesTree,
            "props": {value: this.widgetFilter.name, type: 'widget', "bindable": false},
            "collapsed": false,
            "active": false
          });
          break;
      }
      this.treeData= treeData
      this.hasBinding = this.dataSourceTabs[this.widgetConfig.bindMode].hasBinding;
    }
    else {
      //Reset the BindMapTree and hide validation messages.
      this.treeData = false;

      this.dataSourceTabs[this.widgetConfig.bindMode].hasBinding = false;
      this.hasBinding = false;
    }
  }


  handleTreeNodeClick(node:any) {
    const { dataItem } = node;
    const { id, props } = dataItem;
    this.selectedNode = node;
    if (this.widgetConfig.bindMode === 'widget') {
      this.handleWidgetTreeNodeClick(id, props);
    } else {
      if (this.validateBinding(id, props)) {
        let nodeExpr = split(props.datatype, '.');
        this.nodeType = nodeExpr[nodeExpr.length - 1];
        this.activeWidgetScope.binddataset = 'bind:Variables.' + props.value;
        this.activeNodeType = props.datatype;
        this.fields = this.getFields(props.datatype);
      }
    }
  }

  //Function to handle widget tree node click
  handleWidgetTreeNodeClick (nodeId:any, nodeProps:any){
    if (this.validateBinding(nodeId, nodeProps)) {
      let nodeExpr = split(nodeProps.datatype, '.');
      this.nodeType = nodeExpr[nodeExpr.length - 1];
      this.activeWidgetScope.binddataset = 'bind:Widgets.' + nodeProps.value;
      this.fields = this.getFields(nodeProps.datatype);
    }
  };

  validateBinding(nodeId: string, nodeProps: any) {
    if (!nodeProps.bindable) {
      this.disableBind = true;
      this.toggleValidation(false, 'Widget');
      return;
    }

    this.selectedNode = {dataItem: {id: nodeId, props: nodeProps}};
    this.disableBind = false;

    let activePropertyDetails = this.widgetProperties?.dataset || this.widgetProperties?.metadata || {},
      srcTypes = this.treeService.cleanseTypes(activePropertyDetails?.type, activePropertyDetails?.format),
      /*Combine "bindingType" and "dataType" values into target types.*/
      tgtTypes = this.treeService.cleanseTypes(nodeProps.datatype, nodeProps.format);

    this.selectedNodeProps = nodeProps;
    activePropertyDetails.bindingType = this.treeService.getBindingType(srcTypes, activePropertyDetails.isList);
    /* loop over the source types */
    this.dataSourceTabs[this.widgetConfig.bindMode].hasBinding = this.treeService.validateVariableWidgetBinding({
      'types': srcTypes,
      'bindingType': activePropertyDetails.bindingType
    }, {
      'types': tgtTypes,
      'bindingType': nodeProps.bindingType
    });

    this.toggleValidation(this.dataSourceTabs[this.widgetConfig.bindMode].hasBinding, nodeProps.format || nodeProps.datatype, nodeProps.bindingType);

    return this.dataSourceTabs[this.widgetConfig.bindMode].hasBinding;
  }

  /*
* toggles binding validation status in the view
* @param status current status of the binding(true/false)
*/
  toggleValidation(status: any, targetType?: any, bindingType?: any) {
    this.validation = {};
    if (status) {
      this.validation.message = "MESSAGE_BINDING_SUCCESS";
      this.validation.icon = "done";
      this.hasBinding = true;
    } else {
      this.validation.message = "MESSAGE_BINDING_ERROR";
      this.validation.icon = "error";
      this.hasBinding = false;
    }

    this.validation.selectedDataSourceType = this.treeService.getNodeInfoLabel(targetType, bindingType, false);
  }

  onClose(): void {
    // remove added variableInstance if the variable creation is unsuccessful.
    delete this.variableService.variableInstanceCollection[this.pageWsService.activePageName][this.variableFilter?.name];
    this.handleClose.emit();
  }

  onSubmit(): void {
    let options: any, createdVariable;
    if (this.isSourceMode) {
      if (this.selectedDataSource.operation.serviceType === 'wm.LiveVariable') {
        this.variableService.createLiveVariable({
          'table': this.variableFilter.type,
          'service': this.variableFilter.liveSource,
          'package': this.variableFilter.package,
          'name': this.selectedDataSource.variableNameCreate,
          'startUpdate': this.selectedDataSource.startUpdate,
          'autoUpdate': this.selectedDataSource.autoUpdate,
          'maxResults': this.selectedDataSource.maxResults,
          'bindCount': 1
        }, this.selectedDataSource.startUpdate);
      } else if (this.selectedDataSource.operation.serviceType === 'wm.ServiceVariable') {
        options = {
          'service': this.variableFilter.service,
          'name': this.selectedDataSource.variableNameCreate,
          'operation': this.variableFilter.operation,
          'operationType': this.variableFilter.operationType,
          'returnType': this.variableFilter.type,
          'serviceType': this.variableFilter.serviceType,
          'startUpdate': this.selectedDataSource.startUpdate,
          'autoUpdate': this.selectedDataSource.autoUpdate,
          'operationId': this.selectedDataSource.operation.operationId,
          'controller': this.selectedDataSource.operation.type,
          'isList': this.variableFilter.isList
        };
        if (this.selectedDataSource.operation.type === "QueryExecution") {
          options.maxResults = this.selectedDataSource.maxResults;
        }
        if (this.selectedDataSource.source.type === VARIABLE_CONSTANTS.SERVICE_TYPE_REST) {
          options.sampleParamValues = this.sampleParamsValues;
        }
        this.variableService.createServiceVariable(options);
      } else if (this.selectedDataSource.operation.serviceType === 'wm.CrudVariable') {
        options = {
          'service': this.variableFilter.service,
          'name': this.selectedDataSource.variableNameCreate,
          'operation': this.variableFilter.operation,
          'crudOperationId': this.variableFilter.crudOperationId,
          'operationType': this.variableFilter.operationType,
          'returnType': this.variableFilter.type,
          'serviceType': this.variableFilter.serviceType,
          'startUpdate': this.selectedDataSource.startUpdate,
          'autoUpdate': this.selectedDataSource.autoUpdate,
          'operationId': this.selectedDataSource.operation.operationId,
          'controller': this.selectedDataSource.operation.type,
          'isList': this.variableFilter.isList
        };
        if (this.selectedDataSource.operation.type === "QueryExecution") {
          options.maxResults = this.selectedDataSource.maxResults;
        }
        if (this.selectedDataSource.source.type === VARIABLE_CONSTANTS.SERVICE_TYPE_REST) {
          options.sampleParamValues = this.sampleParamsValues;
        }
        this.variableService.createCrudVariable(options);
      } else if (this.selectedDataSource.operation.serviceType === 'wm.WebSocketVariable') {
        options = {
          'service': this.variableFilter.service,
          'name': this.selectedDataSource.variableNameCreate,
          'type': this.variableFilter.type,
          'startUpdate': this.selectedDataSource.startUpdate,
          'dataUpdateStrategy': this.selectedDataSource.dataUpdateStrategy,
          'operationId': this.selectedDataSource.operation.operationId,
          'isList': this.variableFilter.isList,
          'dataLimit': this.selectedDataSource.dataLimit,
          'owner': 'Page',
          'category': 'wm.WebSocketVariable'
        };

        createdVariable = this.variableService.createVariable('wm.WebSocketVariable', options, options.name);
        this.variableService.store(this.pageWsService.activePageName || 'Main', options.name, createdVariable);
        // $rs.$emit("update-variables-tree", createdVariable); TODO: check how to update root scope after variable creation
      }
      this.pageWsService.saveVariables = true;
    }
    //TODO: check and add the Variable creation steps once Variables service is added
    this.widgetDetails.templateEl = $(this.widgetDefs.template);
    this.widgetDetails.template = this.widgetDefs.template;
    this.handleComplete.emit({ widgetDefs: this.widgetDefs, widgetDetails: this.widgetDetails });
    //TODO: Check root implementation for saving workspace
    /* save the markup changes in workspace */
    this.eventManager.emitPageSave();
  }

}
